import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormSettingModel } from "projects/sepidz-web-framework/src/lib/models/formsettingmodel";
import { takeUntil } from "rxjs/operators";
import { DriverSettlementFormSettingModel } from "../driversettlementformsetting.model";
import { LocalStoreManager } from "projects/sepidz-web-framework/src/lib/services";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { Cost } from "src/app/frontoffice/cost/model/cost.model";
import { Observable } from "rxjs";

@Component({
  selector: "ngx-driversettlementsetting-form",
  templateUrl: "./driversettlementsetting-form.component.html",
  styleUrls: ["./driversettlementsetting-form.component.scss"],
})
export class DriversettlementsettingFormComponent extends BaseFormComponent<any> {
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, public storage: LocalStoreManager) {
    super(selectorService, cd);
  }
  driverSettlementformsetting: DriverSettlementFormSettingModel;
  costList: Cost[] = [];
  hasDefaultCostId: boolean = true;
  async ngOnInit() {
    this.apiName = "DriverSettlementFormSetting";
    this.label = this.translate("ClientApp.FrontOffice.Financial.DriverSettlement.Settings");
    this.customColumnInfoApi = "DriverSettlementFormSetting/GetFormColumnInfo";
    this.changeNoCheck = true;

    super.ngOnInit();
    this.FillData();
  }
  ngOnDestroy(): void {}

  valueChangeByApiName($event) {
    if ($event && $event.apiName === "CostId") {
      this.costList = $event.data;
      this.selectorService.setDataList("CostId", Object.assign([], this.costList));
    }
    if ($event && $event.KeyName === "CostGroupId") {
      if (this.formGroup?.controls["CostGroupId"].value) {
        var FindList = this.costList.filter((f) => f.CostGroupId === this.formGroup.controls["CostGroupId"].value || f.CostGroupId === 0);
        if (FindList?.length == 0) {
          this.selectorService.setDataList("CostId", []);
          this.formGroup.controls["CostId"].disable();
        } else {
          this.formGroup.controls["CostId"].enable();
        }
        this.selectorService.setDataList("CostId", Object.assign([], FindList));
      }
      this.cd.markForCheck();
    }
  }
  CompleteData($event) {
    if ($event && $event.apiName === "Cost") {
      this.costList = $event.data;
      this.selectorService.setDataList("CostId", Object.assign([], this.costList));
    }
    if (this.formGroup?.controls["CostGroupId"].value) {
      var FindList = this.costList.filter((f) => f.CostGroupId === this.formGroup.controls["CostGroupId"].value || f.CostGroupId === 0);
      if (FindList?.length == 0) {
        this.selectorService.setDataList("CostId", []);
        this.formGroup.controls["CostId"].disable();
      } else {
        this.formGroup.controls["CostId"].enable();
      }
      this.selectorService.setDataList("CostId", Object.assign([], FindList));
    }
    this.formGroup?.controls["CostId"].setValue(this.driverSettlementformsetting.CostId);
    this.formGroup?.controls["CostGroupId"].setValue(this.driverSettlementformsetting.CostGroupId);
    this.formGroup?.controls["DeductionForSettlement"].setValue(this.driverSettlementformsetting.DeductionForSettlement);
  }
  FillData() {
    this.httpCommonService
      .getList("DriverSettlementFormSetting")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result: any[]) => {
        if (result?.length > 0) {
          this.driverSettlementformsetting = result[0];
          this.storage.savePermanentData(result[0], ClearableCache.FormSetting);
        }
      });
    this.addControl();
  }
  addControl() {
    if (!this.currentrow && !this.currentrow.CostGroupId) this.formGroup?.get("CostId").disable();
  }
  async saveForm() {
    this.result = JSON.parse(JSON.stringify(this.formGroup.value));
    if (!this.hasDefaultCostId) this.formGroup.controls["CostId"].setValue(null);
    this.save();
  }
  refreshSetting() {
    this.httpCommonService
      .getList("DriverSettlementFormSetting")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result: any[]) => {
        if (result?.length > 0) {
          this.storage.savePermanentData(result[0], ClearableCache.FormSetting);
        }
      });
  }

  public saveSuccessHelper(row?: any) {
    this.isClosing = false;
    this.submitted = true;
    this.selectorService.submitted$.next(this.submitted);
    if (row) {
      this.model["Id"] = row;
      this.id = row;
    }
    this.isSaving = false;
    this.showValidationErrors = false;
    if (this.isNewRow)
      this.sts.showToast(
        "success",
        this.translate("ClientApp.FrontOffice.Financial.DriverSettlement.successful"),
        `${this.translate("ClientApp.FrontOffice.Financial.DriverSettlement.Information")} ${this.label} ${this.translate(
          "ClientApp.FrontOffice.Financial.DriverSettlement.SuccessfullyCreated"
        )}`
      );
    else
      this.sts.showToast(
        "success",
        this.translate("ClientApp.FrontOffice.Financial.DriverSettlement.successful"),
        `${this.translate("ClientApp.FrontOffice.Financial.DriverSettlement.Information")}  ${this.label}  ${this.translate(
          "ClientApp.FrontOffice.Financial.DriverSettlement.SavedSuccessfully"
        )} `
      );
    if (this.changesSavedCallback) this.changesSavedCallback();
    this.currentrow = this.model;
    this.afterupdate();
    this.isSaved = true;
    if (this.isCloseable()) this.close();
    this.selectorService.submitted$.next(false);
  }

  override canDeactivate(): boolean | Observable<boolean> {
    this.closeForm(true);
    return true;
  }
}
